import EventsHandler from "../service/events";
import EVENTS from "../constants/events";

export class LanguageSwitcherToggleComponent {
    private $root: JQuery;
    private events: EventsHandler;

    constructor(element: HTMLElement) {
        this.$root = $(element);
    }

    protected init() {
        this.bindUI();
    }

    protected bindUI() {
        this.$root.on({click: this.handleClick});
        this.events.addListener(EVENTS.LANGUAGE_SWITCHER_OPEN, this.handleLanguageSwitcherOpen);
        this.events.addListener(EVENTS.MENU_OPEN, this.handleLanguageSwitcherClose);
        this.events.addListener(EVENTS.LANGUAGE_SWITCHER_CLOSE, this.handleLanguageSwitcherClose);
    }

    protected handleClick = (ev: any) => {
        ev.preventDefault();
        this.events.emit('true' === this.$root.attr('aria-expanded') ? EVENTS.LANGUAGE_SWITCHER_CLOSE : EVENTS.LANGUAGE_SWITCHER_OPEN);
    }

    protected handleLanguageSwitcherOpen = () => {
        this.$root
            .addClass('is-open')
            .attr('aria-expanded', 'true')
        ;
    }

    protected handleLanguageSwitcherClose = () => {
        this.$root
            .removeClass('is-open')
            .attr('aria-expanded', 'false')
        ;
    }

    public setEventHandler(events: EventsHandler) {
        this.events = events;
        return this;
    }
}